/**
 * Users List Reducer
 * Handles users list state, pagination, and filters
 */

import { USERS_ACTION_TYPES } from '../../actions/usersActions';

const initialState = {
  users: [],
  loading: false,
  error: null
};

const usersListReducer = (state = initialState, action) => {
  switch (action.type) {
    case USERS_ACTION_TYPES.LOAD_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case USERS_ACTION_TYPES.LOAD_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        users: action.payload.items
      };

    case USERS_ACTION_TYPES.LOAD_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        users: []
      };

    case USERS_ACTION_TYPES.DELETE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.filter(user => user.id !== action.payload.userId)
      };

    default:
      return state;
  }
};

export default usersListReducer;